import {Component, OnInit, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {InsightsInfoService} from '../../../shared/services/insights-info.service';




import {UtilsService} from '../../../shared/services/utils.service';
@Component({
    selector: 'app-add-insights-info',
    templateUrl: './add-insights-info.component.html',
    styleUrls: ['./add-insights-info.component.scss'],


})
export class AddInsightsInfoComponent implements OnInit {
    sanitizedContent: SafeHtml | undefined;

    public data: any;
    public toggleMenu = false;
    private _unsubscribeAll: Subject<any>;
    public insightId: any;
    submitting: any = false;
    submitted: any = false;
    contentData: any;
    faqs:any= [{ question: '', answer: '' }]


    constructor(private sanitizer: DomSanitizer,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private insightInfoService: InsightsInfoService) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.insightId = this.activatedRoute.snapshot.params['id'];
        this.refresh();
    }

    refresh() {
        this.insightInfoService.detailByAdmin(this.insightId).subscribe(data => {
            if (data) {
                this.data = data;
                this.faqs = this.data.faqs.length > 0 ? this.data.faqs : [{ question: '', answer: '' }];
                if (this.data && this.data['content']) {
                    this.contentData = this.data['content'];
                }
            } else {
                this.router.navigateByUrl('insights');
            }
        }, error => {
            this.router.navigateByUrl('insights');
        });
    }

    submit() {
        let params = {
            'content': this.contentData ? UtilsService.encodeHtml(this.contentData) : ''
        };
        this.insightInfoService.updateByAdmin(this.insightId, params).subscribe(data => {
            if (data) {
                this.submitting = false;
                this.submitted = false;
            }
        }, error => {
            this.submitting = false;
            this.submitted = false;
        });
    }







    removeFaq(index: number) {
        this.faqs.splice(index, 1);
    }

    addFaq() {
        this.faqs.push({ question: '', answer: '' });
    }

    saveFaq() {

        const cleanedFaqs = this.faqs.filter(
            (faq: any) => faq.question.trim() !== '' && faq.answer.trim() !== ''
        );
        const blogData = { ...this.faqs, faqs: cleanedFaqs };
        const params ={
            faqs : JSON.stringify(blogData.faqs)
        }
        this.insightInfoService.faq(this.insightId, params).subscribe(data => {});
    }
}








